import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useLang } from '../lib/lang';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Shield } from 'lucide-react';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { t } = useLang();
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(form);
      login(res.data.token, res.data.user);
      toast.success('Welcome, Admin!');
      navigate('/admin');
    } catch (e) { toast.error(e.response?.data?.detail || 'Admin login failed'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <Card className="w-full max-w-md bg-white border-border shadow-[0_1px_0_rgba(20,22,26,0.04),0_12px_30px_rgba(20,22,26,0.06)]">
        <CardHeader className="text-center">
          <div className="w-12 h-12 rounded-xl bg-accent flex items-center justify-center mx-auto mb-3"><Shield className="w-6 h-6 text-primary" /></div>
          <CardTitle className="font-display text-2xl">{t('adminAccess')}</CardTitle>
          <CardDescription>{t('signInToAdmin')}</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label>{t('username')}</Label>
              <Input value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} required className="rounded-xl" data-testid="admin-login-username-input" />
            </div>
            <div className="space-y-2">
              <Label>{t('password')}</Label>
              <Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required className="rounded-xl" data-testid="admin-login-password-input" />
            </div>
            <Button type="submit" className="w-full bg-primary text-primary-foreground hover:bg-primary/90 btn-press rounded-xl" disabled={loading} data-testid="admin-login-submit-button">
              {loading ? t('signingIn') : t('signIn')}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
